export default {
  "nav.home": "หน้าแรก",
  "nav.about": "เกี่ยวกับเรา",
  "nav.portfolio": "ผลงาน",
  "nav.partners": "ลูกค้าของเรา",
  "nav.contact": "ติดต่อเรา",
  "hero.title": "เชี่ยวชาญงานสแตนเลส คุณภาพและความพึงพอใจ คือเป้าหมายของเรา",
  "hero.subtitle": "เพื่อคุณภาพและนวัตกรรม ด้วยประสบการณ์มากกว่า 20 ปี",
  "hero.cta": "ขอใบเสนอราคา",
  "hero.btn": "เรียนรู้เพิ่มเติมเกี่ยวกับเรา",
  "about.title": "เกี่ยวกับ บริษัท เจ.เอส.พี.เอ็ม เอ็นจิเนียริ่ง จำกัด",
  "about.subtitle": "ไว้ใจได้ด้านงานสแตนเลส",
  "about.description": "บริษัท เจ.เอส.พี.เอ็ม เอ็นจิเนียริ่ง จำกัด ก่อตั้งในปี พ.ศ. 2547 มุ่งเน้นในงานฝีมือขั้นสูง เพื่อตอบโจทย์ทุกความต้องการ ด้วยประสบการณ์ยาวนานกว่า 20 ปี เราเชี่ยวชาญด้านการผลิตและวิศวกรรมสแตนเลสคุณภาพสูง ครอบคลุมตั้งแต่การออกแบบ ผลิต ไปจนถึงส่งมอบโครงการ ด้วยมาตรฐานที่แม่นยำและเชื่อถือได้",
  "about.experience": "ประสบการณ์",
  "about.projects": "โครงการสำเร็จแล้ว",
  "about.clients": "ลูกค้าที่ไว้วางใจ",
  "portfolio.title": "ผลงานของเรา",
  "portfolio.subtitle": "คุณภาพในทุกผลงาน",
  "portfolio.industrial": "อุปกรณ์อุตสาหกรรม",
  "portfolio.architectural": "งานสถาปัตยกรรม",
  "portfolio.furniture": "งานเฟอร์นิเจอร์",
  "portfolio.food": "ระบบเกรดอาหาร",
  "portfolio.modal.keyFeatures": "จุดเด่น",
  "portfolio.modal.applications": "การใช้งาน",
  "portfolio.modal.close": "ปิด",
  "portfolio.industrial.description": "ผลิตอุปกรณ์สแตนเลสเกรดสูงสำหรับงานอุตสาหกรรม มั่นใจได้ในความทนทาน ป้องกันการกัดกร่อน และมีประสิทธิภาพสูง",
  "portfolio.industrial.feature1": "ผลิตถังและภาชนะตามสั่ง",
  "portfolio.industrial.feature2": "เชื่อมและเก็บงานละเอียด",
  "portfolio.industrial.feature3": "ภาชนะความดันมาตรฐาน",
  "portfolio.industrial.feature4": "ตรวจสอบคุณภาพอย่างเข้มงวด",
  "portfolio.industrial.feature5": "บริการติดตั้งและบำรุงรักษา",
  "portfolio.industrial.app1": "โรงงานเคมี",
  "portfolio.industrial.app2": "การผลิตยา",
  "portfolio.industrial.app3": "โรงกลั่นน้ำมันและก๊าซ",
  "portfolio.industrial.app4": "โรงไฟฟ้า",
  "portfolio.industrial.app5": "ระบบบำบัดน้ำ",
  "portfolio.architectural.description": "สร้างสรรค์งานสถาปัตยกรรมที่ผสมผสานความงามและความแข็งแรง เพิ่มมูลค่าให้อาคารและสิ่งปลูกสร้างสมัยใหม่",
  "portfolio.architectural.feature1": "หน้าต่างสั่งทำ",
  "portfolio.architectural.feature2": "แผงและฉลุลายตกแต่ง",
  "portfolio.architectural.feature3": "องค์ประกอบโครงสร้าง",
  "portfolio.architectural.feature4": "ระบบรางน้ำฝนและกันสาด",
  "portfolio.architectural.feature5": "ออกแบบเพื่อความยั่งยืน",
  "portfolio.architectural.app1": "อาคารพาณิชย์",
  "portfolio.architectural.app2": "โครงการที่อยู่อาศัย",
  "portfolio.architectural.app3": "โครงสร้างพื้นฐานสาธารณะ",
  "portfolio.architectural.app4": "อนุสาวรีย์และประติมากรรม",
  "portfolio.architectural.app5": "งานตกแต่งภายใน",
  "portfolio.furniture.description": "เฟอร์นิเจอร์สแตนเลสที่ออกแบบให้แข็งแรง ทนทาน และสวยงาม เหมาะกับทั้งการใช้งานภายในและภายนอกอาคาร",
  "portfolio.furniture.feature1": "ดีไซน์สั่งทำตามความต้องการ",
  "portfolio.furniture.feature2": "โครงสร้างแข็งแรงและทนทาน",
  "portfolio.furniture.feature3": "พื้นผิวสแตนเลสเงางาม ทำความสะอาดง่าย",
  "portfolio.furniture.feature4": "เหมาะสำหรับทั้งบ้านและเชิงพาณิชย์",
  "portfolio.furniture.feature5": "อายุการใช้งานยาวนาน คุ้มค่า",
  "portfolio.furniture.app1": "โต๊ะและเก้าอี้สแตนเลส",
  "portfolio.furniture.app2": "ชุดครัวสแตนเลส",
  "portfolio.furniture.app3": "ตู้และชั้นวางของ",
  "portfolio.furniture.app4": "เฟอร์นิเจอร์กลางแจ้ง",
  "portfolio.furniture.app5": "เฟอร์นิเจอร์เชิงพาณิชย์ เช่น ร้านอาหารและคาเฟ่",
  "portfolio.food.description": "ระบบสแตนเลสเกรดอาหารที่ได้มาตรฐานด้านความสะอาดและความปลอดภัย มั่นใจได้ว่าผลิตภัณฑ์มีคุณภาพและถูกสุขลักษณะ",
  "portfolio.food.feature1": "วัสดุผ่านการรับรอง FDA",
  "portfolio.food.feature2": "ออกแบบตามหลักสุขาภิบาล",
  "portfolio.food.feature3": "พื้นผิวทำความสะอาดง่าย",
  "portfolio.food.feature4": "ระบบควบคุมอุณหภูมิ",
  "portfolio.food.feature5": "อุปกรณ์การผลิตอัตโนมัติ",
  "portfolio.food.app1": "โรงงานแปรรูปอาหาร",
  "portfolio.food.app2": "ครัวอุตสาหกรรม",
  "portfolio.food.app3": "โรงงานผลิตเครื่องดื่ม",
  "portfolio.food.app4": "ระบบแปรรูปอาหาร",
  "portfolio.food.app5": "อุปกรณ์ร้านอาหาร",
  "partners.title": "พันธมิตรที่ไว้วางใจ",
  "partners.subtitle": "ร่วมงานกับผู้นำในอุตสาหกรรม",
  "partners.brochure": "ดูโปรไฟล์บริษัท",
  "contact.title": "ติดต่อเรา",
  "contact.subtitle": "พร้อมที่จะร่วมงานกับเรา?",
  "contact.address": "6/5 หมู่ 5 ถนนบ้านกล้วย-ไทรน้อย ต.พิมลราช อ.บางบัวทอง จ.นนทบุรี 11110 ประเทศไทย",
  "contact.phone": "+66 (0)2-923-3732-3",
  "contact.email": "jspm2506@yahoo.com",
  "contact.form.name": "ชื่อ-นามสกุล",
  "contact.form.email": "อีเมล",
  "contact.form.company": "บริษัท",
  "contact.form.phone": "เบอร์โทร",
  "contact.form.project": "รายละเอียดโครงการ / ข้อความ",
  "contact.form.submit": "ส่งข้อความ",
  "footer.rights": "สงวนลิขสิทธิ์"
};
